import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { generateConfig } from '../../utils/api';
import { handleApiError } from '../../utils/apiErrorHandler';
import { 
  fetchLogsStart, 
  fetchLogsSuccess, 
  fetchLogsFailure,
  addLogSuccess 
} from '../slices/clientPortalLogsSlice';
import { logError } from '../../utils/logger';

// Convert to createAsyncThunk pattern
export const fetchClientPortalLogs = createAsyncThunk(
  'clientPortalLogs/fetchLogs',
  async (clientId, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.get(
        `${baseURL}/api/clients/${clientId}/portal-logs`, 
        config
      );
      
      return response.data.logs;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

// Convert to createAsyncThunk pattern
export const createPortalLog = createAsyncThunk(
  'clientPortalLogs/createLog',
  async ({ clientId, logData }, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.post(
        `${baseURL}/api/clients/${clientId}/portal-logs`,
        logData,
        config
      );
      
      return response.data.log;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

// Legacy function implementations, keeping for backward compatibility
// but they now delegate to the new createAsyncThunk versions
export const fetchClientPortalLogsLegacy = (clientId) => async (dispatch) => {
  dispatch(fetchLogsStart());
  
  try {
    dispatch(fetchClientPortalLogs(clientId))
      .unwrap()
      .then(logs => dispatch(fetchLogsSuccess(logs)))
      .catch(error => dispatch(fetchLogsFailure(error)));
  } catch (error) {
    dispatch(fetchLogsFailure(error.message));
  }
};

export const createPortalLogLegacy = (clientId, logData) => async (dispatch) => {
  try {
    dispatch(createPortalLog({ clientId, logData }))
      .unwrap()
      .then(log => dispatch(addLogSuccess(log)))
      .catch(error => console.error('Failed to create portal log:', error));
  } catch (error) {
    console.error('Failed to create portal log:', error);
  }
}; 